import { memo, useState } from 'react';
import { Badge, Box, Button, Flex, HStack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

function TransferNoteOfPresentationItem({ item, error, onRetry }) {
	const { t } = useTranslation();
	const [retrying, setRetrying] = useState(false);

	const handleRetry = async () => {
		if (retrying) return;
		setRetrying(true);
		try {
			await onRetry();
		} finally {
			setRetrying(false);
		}
	};

	return (
		<Flex
			justifyContent="space-between"
			alignItems="center"
			borderWidth="1px"
			borderColor="red.200"
			borderRadius={6}
			px={3}
			py={2}
		>
			<HStack spacing={2} minW={0}>
				<Badge colorScheme="orange">{item?.number ?? 'N/A'}</Badge>
				<Badge colorScheme="red">{typeof error === 'string' ? error : 'error'}</Badge>
				<Box minW={0} fontSize="sm" color="gray.700" isTruncated>
					<Text isTruncated>{item?.id}</Text>
				</Box>
			</HStack>
			<Button size="xs" colorScheme="red" variant="outline" onMouseDown={handleRetry} isLoading={retrying}>
				{t('Retry')}
			</Button>
		</Flex>
	);
}

export default memo(TransferNoteOfPresentationItem);
